import React from 'react';
import Paragraphs from '../Paragraphs';
import BlogPost from './BlogPost';
import ScrollToTop from '../ScrollToTop';
import SEO from '../../components/SEO';
import SocialShare from '../../components/SocialShare';
import '../../css/blog-single.css';
import '../../css/blog.css';
import { withRouter, Link } from 'react-router-dom';
import { defaultBlogKeywords } from '../../pages/Blog';

function randomIntFromInterval(min, max) {
  // including min and max
  return Math.floor(Math.random() * (max - min + 1) + min);
}

let NavigationControls = withRouter(({ type, history, nextId, prevId }) => {
  return (
    <div className="navigation-btns">
      {prevId && (
        <button
          className="btn btn-outline btn-outline-blue"
          onClick={() => history.push(`/blog/${type}/${prevId}`)}
        >
          Previous Story
        </button>
      )}
      {nextId && (
        <button
          className="btn btn-outline btn-outline-blue"
          onClick={() => history.push(`/blog/${type}/${nextId}`)}
        >
          Next Story
        </button>
      )}
    </div>
  );
});

let SingleBlog = ({ id, data, allBlogs, type }) => {
  let blogPosts = Object.keys(allBlogs),
    indexOfId = blogPosts.indexOf(id);

  let prevId =
    indexOfId !== undefined && indexOfId - 1 >= 0 && blogPosts[indexOfId - 1]
      ? blogPosts[indexOfId - 1]
      : null;
  let nextId =
    indexOfId !== undefined &&
    indexOfId + 1 < blogPosts.length &&
    blogPosts[indexOfId + 1]
      ? blogPosts[indexOfId + 1]
      : null;
  blogPosts.splice(indexOfId, 1);

  let extract = () => {
    let extractThree = [];
    for (let i = 0; i < 3; i++) {
      let id1 = randomIntFromInterval(0, blogPosts.length - 1);
      if (blogPosts[id1]) extractThree.push(blogPosts[id1]);
      blogPosts.splice(id1, 1);
    }
    return extractThree;
  };

  const url = window.location.href;
  let extractThree = extract();
  return (
    <>
      <SEO
        title={`WE3 Academy | ${data.seo?.title ?? data.title} | Blog`}
        description={data.seo?.description ?? data.tldr}
        keywords={data.seo?.keywords ?? defaultBlogKeywords}
        link={`/${type}/${id}`}
        img={data.img}
        type="article"
      >
        <meta property="article:published_time" content={data.fullDate} />
        <meta property="article:section" content={type} />
        <meta property="article:tag" content={type} />
        <script type="application/ld+json">
          {`{
            "@context" : "http://schema.org",
            "@type" : "Article",
            "name" : ${data.title},
            "datePublished" : ${data.date},
            "description" : ${data.tldr},
            "image" : ${data.img},
            "url" : “https://we3academy.com/blog/${type}/${id}”,
          }
        `}
        </script>
      </SEO>

      <div className="single-post">
        <ScrollToTop />
        <p>
          <Link to="/blog">Back To All Blogs</Link>
        </p>
        <div className="top-container">
          <div className="img-container">
            <img src={data.img} alt={data.imgAlt} />
          </div>
          <div className="content-container">
            <div>
              <h1 className="single-post-title">{data.title}</h1>
              <p className="tldr">TLDR; {data.tldr}</p>
            </div>
            <div>
              <SocialShare url={url} />
              <h5 className="author-date">
                {/* By {data.author} | {data.date} */}
                {data.date}
              </h5>
            </div>
          </div>
        </div>

        <div className="story">
          {data && data.text && data.text.length > 0 ? (
            <Paragraphs data={data.text} />
          ) : (
            data.text
          )}
          <NavigationControls nextId={nextId} prevId={prevId} type={type} />
        </div>
        <hr />
        <p>
          <Link to="/blog">Read More Blogs</Link>
        </p>
        {extractThree && extractThree.length > 1 && (
          <>
            <div className="more-stories">
              {extractThree.map((blog) =>
                blog ? (
                  <BlogPost
                    h2Heading={true}
                    key={blog}
                    id={blog}
                    blog={allBlogs[blog]}
                    type={type}
                  />
                ) : null
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default SingleBlog;
